import { Tag, TagDTO } from "./tags.types";

const parseName = (dto: TagDTO): string => {
  if (typeof dto === "string") return dto.trim();
  if (dto && typeof dto.name === "string") return dto.name.trim();
  return "";
};

const parseCount = (dto: TagDTO): number => {
  if (!dto || typeof dto === "string") return 0;
  const count = Number(dto.count);
  return Number.isFinite(count) ? count : 0;
};

export const parseTags = (raw: unknown): Tag[] => {
  if (!Array.isArray(raw)) return [];

  return (raw as TagDTO[]).reduce<Tag[]>((tags, dto) => {
    const name = parseName(dto);
    if (name) tags.push({ name, count: parseCount(dto) });
    return tags;
  }, []);
};
